// extracted by mini-css-extract-plugin
module.exports = {"card":"CategoryCard_card_3JQT6","heading":"CategoryCard_heading_1_V05"};